export default "__VITE_ASSET__DOv4U_Mo__"